import React, { useMemo } from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import { PanelHeader } from 'js/components';

import JiraConfiguration from './configurations/JiraConfiguration';
import { CONNECTOR_SERVICES } from 'js/data/connectors';
import styles from './ConnectorSettings.module.scss';

const CONNECTOR_CONFIGURATIONS = {
  'jira-cloud': JiraConfiguration,
  // Future connector types will be added here
  // 'jira-server': JiraServerConfiguration,
  // slack: SlackConfiguration,
  // github: GitHubConfiguration,
};

function ConnectorCreate({
  selectedType,
  onBack,
  onSubmit,
  onCancel,
  onTest,
  workspace,
  onQueryIssueFields,
}) {
  const ConfigurationComponent = CONNECTOR_CONFIGURATIONS[selectedType];
  const serviceInfo = useMemo(
    () => CONNECTOR_SERVICES.find((service) => service.id === selectedType),
    [selectedType]
  );

  if (!workspace) {
    return (
      <div>
        <PanelHeader size="flex">
          <div className="panel-body-no-label px-4">
            <h2>Add a new connector</h2>
          </div>
        </PanelHeader>
        <div className="content">
          <Card>
            <CardBody>
              <div className="text-center py-4">
                <p className="text-muted">No workspace selected</p>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }

  if (!selectedType || !ConfigurationComponent || !serviceInfo) {
    return (
      <div>
        <PanelHeader size="flex">
          <div className="panel-body-no-label px-4">
            <h2>Add a new connector</h2>
          </div>
        </PanelHeader>
        <div className="content">
          <Card>
            <CardBody>
              <div className="text-center py-4">
                <p className="text-muted">Invalid service type selected</p>
                <Button color="primary" onClick={onCancel}>
                  Back to Service Selection
                </Button>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PanelHeader size="flex">
        <div className="panel-body-no-label px-4">
          <h2>Add a new connector</h2>
        </div>
      </PanelHeader>
      <div className="content">
        <Card>
          <CardBody>
            <div className={styles['service-card-configuring-container']}>
              <div className={styles['service-card']}>
                <span className={styles['service-card-icon']}>
                  <img src={serviceInfo.logo} alt={serviceInfo.name} />
                </span>
                <span className={styles['service-card-title']}>
                  Configuring {serviceInfo.name}
                </span>
                <span className={styles['service-card-description']}>
                  {serviceInfo.description}
                </span>
              </div>
            </div>

            {ConfigurationComponent && (
              <ConfigurationComponent
                onSubmit={onSubmit}
                onBack={onBack}
                onCancel={onCancel}
                onTest={onTest}
                isEdit={false}
                workspaceId={workspace?.id}
                onQueryIssueFields={onQueryIssueFields}
              />
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default ConnectorCreate;
